import React, { useEffect } from 'react';
import "./ClaimsPageStyles.scss"
import { useClaims } from "./hooks/useClaims";
import ClaimItem from "./claimItem/claimItem";
import ButtonBack from "../../components/Buttons/buttonBack/ButtonBack";

const ClaimsPage = () => {

    const { claims, loading, fetchClaims, updateClaimAttachments, fetchClaimsCount } = useClaims();

    useEffect(() => {
        fetchClaims();
    }, []);

    const handleUpdateClaim = async (guid, attachmentIds) => {

        try {
            const result = await updateClaimAttachments(guid, attachmentIds);

            await fetchClaims();

            const count = await fetchClaimsCount();

            return result;
        } catch (error) {
            console.error('Ошибка в handleUpdateClaim:', error);
            await fetchClaims();
            throw error;
        }
    };

    if (loading) {
        return <div className="claims-loading">Загрузка...</div>;
    }

    return (
        <div className={"claim_list max--width--control"}>
            <ButtonBack/>

            {claims.length === 0 ? (
                <div className="claims-empty">Нет активных претензий</div>
            ) : (
                claims.map((claim) => (
                    <ClaimItem
                        key={claim.guid}
                        item={claim}
                        onUpdate={handleUpdateClaim}
                    />
                ))
            )}
        </div>
    );
};

export default ClaimsPage;